var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "+_vm._s(_vm.session)+" "),_c('br'),_c('small',[_vm._v("0.0.1 - navigation menu")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }